import Api from "../config/Axios";
// import { getZoneList } from "../../services/zone.service";

export const createZone = (data) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
  };
  return Api.post("api/web/zone/create", data, config);
};

export const getZoneList = (token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get("api/web/zone/list", config);
};

export const getStoreList = (token, user_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get("api/web/store/list", config);
};

export const getZoneOne = (token, user_id, zone_id) => {
  const config = {
    headers: {
      Authorization: 'Bearer '+(token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get("api/web/zone/"+zone_id, config);
};

export const postDashboardlist = async (token, user_id, data ) => {
  const config = {
    headers: {
      Authorization: "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get("api/web/tasks/zone-rider-order-stats?storeId="+data, config);
};

export const postZoneValidateLocation = async (token, user_id, zId, data ) => {
  const config = {
    headers: {
      Authorization: "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.patch(`api/web/store/${zId}`,data, config);
};

export const getZoneStoreSingle = (token, user_id, id) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : ""), UserId: parseInt(user_id ? user_id : "")}};
  return Api.get(`api/web/zone-store/${id}`, config)
};

export const postZoneStoreAdd = (token, user_id, data) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : ""), UserId: parseInt(user_id ? user_id : "")}};
  return Api.post(`api/web/zone-store/create`, data, config)
};

export const patchZoneEdit = (token, user_id, data, id) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : ""), UserId: parseInt(user_id ? user_id : "")}};
  return Api.patch(`api/web/zone-store/update`, data, config)
};